// extracted by mini-css-extract-plugin
export default {"button":"wk-z","reviewSort":"xk-z"};